import { UserRole } from '@/core/auth/types/auth.types';
import { DEFAULT_GRADE_SLUG, GradeSlug } from '@/shared/utils/curriculum/curriculum';

export function redirectUrlForRole(role: UserRole, gradeSlug: GradeSlug | null): string {
  if (role === UserRole.Teacher) return '/teacher';
  return `/${gradeSlug ?? DEFAULT_GRADE_SLUG}/student-home`;
}
